import api from "./api";

export interface FeatureFlags {
    ENABLE_REGISTRATION: boolean;
    [key: string]: boolean;
}

export const getFeatureFlags = async (): Promise<FeatureFlags> => {
    const response = await api.get<FeatureFlags>("/features");
    return response.data;
};
